import React, { FunctionComponent } from "react";
import { Form, Input } from "antd";
import FormLabel from "./FormLabel";
import styles from "../BiformLayout.module.scss";
import { QuestionComponentProps } from "../helper";
import { buildRules } from "../formUtils";

// LONG_TEXT — multi-line text input.
const LongText: FunctionComponent<QuestionComponentProps> = ({ question, disabled = false }) => (
  <Form.Item
    name={question.id}
    label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}
    rules={buildRules(question)}
    className={styles.disableTextInput}
  >
    <Input.TextArea disabled={disabled} placeholder={question.placeholder || "Enter"} autoSize={{ minRows: 3, maxRows: 5 }} />
  </Form.Item>
);

export default LongText;
